import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  CompanyContact extends  DBObject {  private static readonly _DESIGNATION: number = 0 ;
  private static readonly _EMAIL: number = 1 ;
  private static readonly _LINKEDIN: number = 2 ;
  private static readonly _NAME: number = 3 ;
  private static readonly _PHONE: number = 4 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _name: string = '' ;
  private _designation: string = '' ;
  private _email: string = '' ;
  private _phone: string = '' ;
  private _linkedIn: string = '' ;
 public constructor ( d3eParams ? : Partial<{designation: string, email: string, linkedIn: string, name: string, phone: string}> ) {
 super();

this.setDesignation(d3eParams?.designation ?? '');

this.setEmail(d3eParams?.email ?? '');

this.setLinkedIn(d3eParams?.linkedIn ?? '');

this.setName(d3eParams?.name ?? '');

this.setPhone(d3eParams?.phone ?? '');
 }
  public get d3eType (  ) : string {
 return 'CompanyContact' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get name (  ) : string {
 return this._name ; 
 }
  public setName ( val : string ) : void {
 let isValChanged :boolean=this._name !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CompanyContact._NAME,this._name);

this._name=val;

this.fire('name',this);
 }
  public get designation (  ) : string {
 return this._designation ; 
 }
  public setDesignation ( val : string ) : void {
 let isValChanged :boolean=this._designation !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CompanyContact._DESIGNATION,this._designation);

this._designation=val;

this.fire('designation',this);
 }
  public get email (  ) : string {
 return this._email ; 
 }
  public setEmail ( val : string ) : void {
 let isValChanged :boolean=this._email !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CompanyContact._EMAIL,this._email);

this._email=val;

this.fire('email',this);
 }
  public get phone (  ) : string {
 return this._phone ; 
 }
  public setPhone ( val : string ) : void {
 let isValChanged :boolean=this._phone !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CompanyContact._PHONE,this._phone);

this._phone=val;

this.fire('phone',this);
 }
  public get linkedIn (  ) : string {
 return this._linkedIn ; 
 }
  public setLinkedIn ( val : string ) : void {
 let isValChanged :boolean=this._linkedIn !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CompanyContact._LINKEDIN,this._linkedIn);

this._linkedIn=val;

this.fire('linkedIn',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case CompanyContact._NAME : {
 return this._name ; 
 }

case CompanyContact._DESIGNATION : {
 return this._designation ; 
 }

case CompanyContact._EMAIL : {
 return this._email ; 
 }

case CompanyContact._PHONE : {
 return this._phone ; 
 }

case CompanyContact._LINKEDIN : {
 return this._linkedIn ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : CompanyContact {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :CompanyContact=( dbObj as CompanyContact );

obj.id=this.id;

obj.setName(this._name);

obj.setDesignation(this._designation);

obj.setEmail(this._email);

obj.setPhone(this._phone);

obj.setLinkedIn(this._linkedIn);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case CompanyContact._NAME : {
 this.setName(( value as string ));
 break; }

case CompanyContact._DESIGNATION : {
 this.setDesignation(( value as string ));
 break; }

case CompanyContact._EMAIL : {
 this.setEmail(( value as string ));
 break; }

case CompanyContact._PHONE : {
 this.setPhone(( value as string ));
 break; }

case CompanyContact._LINKEDIN : {
 this.setLinkedIn(( value as string ));
 break; }
 }
 }
 }